/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { fonts, colors } from '@blend/consumer-components';

export namespace CenteredWrapper {
  export interface Props extends React.HTMLAttributes<HTMLDivElement> {}
}

const styles = StyleSheet.create({
  wrapper: {
    width: '100%',
    textAlign: 'center',
    fontSize: 18,
    fontWeight: fonts.weight.medium,
    color: colors.darkerGray,
  },
});

export const CenteredWrapper: React.FC<CenteredWrapper.Props> = ({ children, ...htmlProps }) => {
  return (
    <div className={css(styles.wrapper)} {...htmlProps}>
      {children}
    </div>
  );
};
